import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';

function BioCard() {
  return (
    <>
      <Helmet>
        <title>Allowance Track | About</title>
        <meta name='title' content='Allowance Track | About' />
        <meta
          name='description'
          content="Discover the ultimate allowance tracker! Allowance Track empowers parents to effortlessly oversee and manage their kids' allowances with a user-friendly platform. Engage in setting tasks, tracking progress, and rewarding achievements. Start simplifying your financial parenting journey today!"
        />
        <meta
          name='keywords'
          content='allowance tracker app, allowance tracker, allowance tracking, children allowance management, family finance tool, kids money management, task rewards system, financial literacy for kids, parental control finance, digital allowance system, child allowance app, manage kids money, financial planning for kids, allowance tracking software'
        />
        <meta property='og:title' content='Allowance Track | About' />
        <meta
          property='og:description'
          content="Discover the ultimate allowance tracker! Allowance Track empowers parents to effortlessly oversee and manage their kids' allowances with a user-friendly platform. Engage in setting tasks, tracking progress, and rewarding achievements. Start simplifying your financial parenting journey today!"
        />
        <meta property='og:type' content='website' />
        <meta property='og:url' content={`${process.env.REACT_APP_BASE_URL}`} />
        <meta name='twitter:card' content='summary' />
        <meta name='twitter:title' content='Allowance Track | About' />
        <meta
          name='twitter:description'
          content="Discover the ultimate allowance tracker! Allowance Track empowers parents to effortlessly oversee and manage their kids' allowances with a user-friendly platform."
        />
      </Helmet>
      <motion.div
        initial={{ opacity: '0' }}
        animate={{ opacity: '1' }}
        className='w-100 d-flex justify-content-center'
        id='bio'
      >
        <div
          className='card mx-3 my-5'
          style={{
            maxWidth: '800px',
            width: '100%',
          }}
          id='bio-card'
        >
          <div
            className='card-body p-5 v-cont'
            style={{ textAlign: 'left' }}
            id='bio-text'
          >
            <h5 className='card-title fs-2 v-target'>About Allowance Track</h5>
            <p className='card-text'>
              Allowance Track is a modern, family-friendly platform designed to
              help parents teach their children valuable financial skills
              through hands-on experience with chores and allowance management.
              <br />
              <br />
              Our mission is to empower families by providing intuitive tools
              that make tracking chores, managing allowances, and rewarding
              achievements simple and engaging. We believe that financial
              literacy starts at home, and the habits children develop early can
              shape their relationship with money for a lifetime.
              <br />
              <br />
              <strong>Key Features:</strong>
              <br />
              • Easy task creation and tracking for parents and kids
              <br />
              • Transparent allowance management and balance tracking
              <br />
              • Goal setting to encourage saving and discipline
              <br />
              • Family-friendly interface designed for all ages
              <br />
              • Secure and private: your family's data stays safe
              <br />
              <br />
              Whether you're looking to instill responsibility, encourage saving
              habits, or simply streamline how your family handles chores and
              rewards, Allowance Track is here to help your family succeed.
            </p>
            {/* Old about text:
            <h5 className='card-title fs-2 v-target'>
              Aden - The Creator of Allowance Track
            </h5>
            <p className='card-text'>
              At only 9 years old and in the fourth grade, Aden became very
              interested in building his own full-stack web applications while
              in elementary school in the Atlanta metropolitan area. Fully self
              taught in his free time, he learned full-stack coding and mastered
              front and back-end development as well as machine learning and
              artificial intelligence.
              <br />
              <br />
              He developed and built Allowance Track on his own from the ground
              up to help kids around the world track their chores and allowance
              earnings, and learn to stay disciplined and focused on their
              goals. In addition to coding, Aden loves soccer, jui jitsu,
              kickboxing, and playing piano.
              <br />
              <br />
              Here are some of the technologies he loves to work with: HTML,
              CSS, Javacript, React, Node.JS, Python, Tailwind, Webhooks, API
              development and integration, machine learning, OpenAI integration,
              ML model development, training, and inferencing, neural network
              development, Payment gateway implementation, Stripe development,
              SMTP server integration, Cloud solutions, Azure, MongoDb,
              SQL/No-SQL databases.
              <br />
              <br />
              Also, check out another AI enhanced web app that Aden created at{' '}
              <a
                href='http://acronotes.com'
                target='_blank'
                rel='noopener noreferrer'
              >
                acronotes.com
              </a>
            </p>
            */}
          </div>
        </div>
      </motion.div>
    </>
  );
}

export default BioCard;
